module.exports = __webpack_public_path__ + "img/product-shansuan-sysm-01.e1aeb46b.png";